<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="forgetPassword"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/change-img.png"
                alt="login"
                class="forget-img"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h2 class="header-title"><b>Change Password</b></h2>
                </div>

                <div>
                  <div class="input-field vx-row">
                    <vs-input
                      type="password"
                      class="input-box w-full starlabel"
                      icon-pack="feather"
                      icon="icon-lock"
                      icon-no-border
                      :placeholder="$t('label.input.password')"
                      v-model="changePassword.password"
                      :danger="isDanger"
                      :danger-text="validationMsg"
                      @input="validatePassword"
                    >
                      <template #message-danger> Required </template>
                    </vs-input>
                    <vs-input
                      icon-after="true"
                      icon="icon iconvisibility"
                      v-model="changePassword.repeatPassword"
                      type="password"
                      id="confirmPassword"
                      :placeholder="$t('label.input.repeatpassword')"
                      class="password w-full mt-6"
                      :visiblePassword="true"
                      v-on:icon-click="visibilityHandling"
                      :danger="isDangerRepeat"
                      :danger-text="RepeatValidationMsg"
                      @input="validateRepeatPassword"
                    />
                    <vs-button
                      class="subm-chack"
                      :disabled="disableSubmit"
                      @click="updatePassword"
                    >
                      {{ $t("Submit") }}
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { removeHeader } from "@/http";
let visiblePassword = false;
export default {
  data() {
    return {
      isDanger: false,
      validationMsg: null,
      isDangerRepeat: false,
      RepeatValidationMsg: null,
      disableSubmit: true,
      isPasswordValid: true,
      hasVisiblePassword: false,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      email: "",
      username: "",
      message: "",
      changePassword: {
        password: "",
        repeatPassword: "",
      },
    };
  },
  computed: {
    ...mapState({
      verUsername: (state) => state.dashboard.username,
    }),
    getUserDetail() {
      return this.$store.getters["auth/userDetail"];
    },
  },
  watch: {
    activeTab(newValue) {
      if (newValue === 1) {
        this.$nextTick(() => {
          this.setupPasswordField();
        });
      }
    },
  },
  methods: {
    validatePassword() {
      const password = this.changePassword.password;

      const lengthRegex = /.{8,}/;
      const specialCharRegex = /[^A-Za-z0-9]/;
      const capitalLetterRegex = /[A-Z]/;
      const numberRegex = /[0-9]/;

      if (password.trim() === "") {
        this.isPasswordValid = false;
        this.validationMessage = "Password is required.";
        this.disableSubmit = true;
        return;
      }

      const isValid =
        lengthRegex.test(password) &&
        specialCharRegex.test(password) &&
        capitalLetterRegex.test(password) &&
        numberRegex.test(password);
      this.isPasswordValid = isValid;

      if (!this.isPasswordValid && this.changePassword.password.length > 0) {
        this.isDanger = true;
        this.validationMsg =
          "Password must be at least 8 characters long, contain atleat one special character, one capital letter, and one number.";
      } else {
        this.isDanger = false;
        this.validationMsg = null;
      }
    },
    validateRepeatPassword() {
      if (this.changePassword.password !== this.changePassword.repeatPassword) {
        this.isDangerRepeat = true;
        this.RepeatValidationMsg =
          "Password mismatch! Please enter correct password.";
        this.disableSubmit = true;
      } else {
        this.isDangerRepeat = false;
        this.RepeatValidationMsg = null;
        this.disableSubmit = false;
      }
    },

    visibilityHandling() {
      this.hasVisiblePassword = !this.hasVisiblePassword;
    },
    getOrderStatusColor(status) {
      if (status == "disabled") return "danger";
      if (status == "Enabled") return "success";
      return "primary";
    },
    async updatePassword() {
      if (
        !this.changePassword.password ||
        !this.changePassword.repeatPassword
      ) {
        this.warningPopup = true;
        this.errorMessage = "";
        this.warningText = "Fill the required fields!";
      } else {
        try {
          const data = {
            password: this.changePassword,
            id: this.getUserDetail.id,
          };
          await this.$store.dispatch("auth/changePasswordAction", data);
          this.$store.dispatch("auth/logout").then(() => {
            removeHeader("Authorization");
            sessionStorage.removeItem("ngb:user");
            sessionStorage.removeItem("ngb:bearer_token");
            sessionStorage.removeItem("ngb:user_token");
            this.$router.push("/login");
          });

          this.$swal({
            title: "Success",
            icon: "success",
            text: "Password Changed Successfully!",
            type: "success",
          });
          this.resetForm();
        } catch (e) {
          this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
            "The parameter",
            ""
          );
          this.warningPopup = true;
          this.warningText = "";
          this.errors = e.message.errors;
        }
      }
    },
    async getverifyusername() {
      try {
        await this.$store.dispatch(
          "dashboard/setverifyusername",
          this.username
        );
        this.$router.push("/forgetEmail");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    resetForm() {
      this.changePassword.password = "";
      this.changePassword.repeatPassword = "";
      this.isDanger = false;
      this.validationMsg = null;
      this.isDangerRepeat = false;
      this.RepeatValidationMsg = null;
      this.disableSubmit = true;
    },
  },
  mounted() {
    const passwordField = document.querySelector(".password");
    const iel = document.createElement("i");
    iel.classList.add(
      "vs-icon",
      "notranslate",
      "icon-scale",
      "icon-inputx",
      "notranslate",
      "vs-input--icon",
      "feather",
      "icon",
      "icon-lock",
      "null",
      "icon-no-border"
    );
    passwordField.firstElementChild.append(iel);
    const passwordInput = document.getElementById("confirmPassword");
    const icon = passwordField.querySelector(".vs-input--icon");
    icon.addEventListener("click", function () {
      if (visiblePassword) {
        passwordInput.type = "password";
        icon.textContent = "icon iconvisibility";
      } else {
        passwordInput.type = "text";
        icon.textContent = "icon iconvisibility_off";
      }
      visiblePassword = !visiblePassword;
    });
    this.resetForm();
  },
};
</script>

<style lang="scss">
#forgetPassword {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
.forget-img {
  height: 290px;
}
.input-field {
  margin-left: 2rem;
}
.submit-button {
  margin-top: 3rem;
  margin-left: 6rem;
}
.subm-chack {
  margin-top: 3rem;
  margin-left: 7rem;
}
.input-box {
  margin-right: 3rem;
}
.password {
  margin-right: 3rem;
}
.header-title {
  margin-left: 2rem;
  margin-bottom: 2rem;
}
#confirmPassword {
  padding-left: 3rem !important;
}
.vs-input--input.normal ~ .vs-input--icon.feather {
  top: 7px !important;
}
.vs-input--placeholder {
  top: auto;
  margin-left: 15px;
}
.vs-input--icon {
  top: 12px !important;
}
.vs-input--icon.icon-after {
  border-left: 15px !important;
  right: 16px !important;
}
.vs-input--input.hasIcon.icon-after-input + .vs-input--placeholder {
  padding-left: 40px !important;
}
</style>
